"use client"

import { useQuery } from '@tanstack/react-query'
import { getMe, type Me } from '@/services/user'

export function useMe() {
  const isClient = typeof window !== 'undefined'
  const path = isClient ? window.location.pathname : ''
  const isPublicRoute = path === '/' || path === '/login' || path === '/twofa' || path === '/activate' || path === '/reset-password'
  return useQuery<Me>({
    queryKey: ['me'],
    queryFn: getMe,
    enabled: isClient && !isPublicRoute,
    retry: (failureCount, err: any) => {
      const status = err?.response?.status
      if (status === 401 || status === 403) return false
      return failureCount < 2
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
